export const domoEmbeds = {
  count: 1,
  rows: [
    {
      description: 'Average Change in BMI',
      domoCardUrl: 'domoCardUrl',
      embedId: 'n5Q9Ya',
      id: 1,
      isStory: false,
      name: 'Patient Outcomes',
      priority: 2,
      roleGroup: 'Provider',
    },
  ],
};

export const createdDomoEmbed = {
  description: 'Patients with activities',
  domoCardUrl: 'url',
  embedId: 'kR58X',
  name: 'Onboarding',
  priority: 1,
  roleGroup: 'Organization',
  section: 'Onboarding and Demographics',
};

export const editedDomoEmbeds = {
  description: 'Patients by Onboarding Stage',
  embedId: 'eR59s',
  priority: 2,
  roleGroup: 'Patient',
  section: 'Patient Outcomes',
};
